import React, { useRef, useState } from "react";
import { useMotionValueEvent } from "framer-motion";
import { processFrames } from "../data/films";
import { useSectionProgress } from "../hooks/useSectionProgress";
import { ProjectorGate } from "./process/ProjectorGate";
import { ClientChannel } from "./process/ClientChannel";
export function FilmStripProcess() {
  const sectionRef = useRef<HTMLElement>(null);
  const progress = useSectionProgress(sectionRef);
  const [step, setStep] = useState(0);
  const lastStep = processFrames.length - 1;
  useMotionValueEvent(progress, "change", p => {
    const next = Math.min(lastStep, Math.floor(p * processFrames.length));
    setStep(s => s === next ? s : next);
  });
  return (
    // Tall runway: the frame pins while scroll feeds each step through the gate.
    <section ref={sectionRef} id="process" className="relative h-[400vh]" aria-labelledby="process-heading" data-id="element-100" data-mp="2qv5r6lg317bo">
      <div className="sticky top-0 flex h-[100svh] flex-col overflow-hidden pb-5 pt-20 md:pb-8 md:pt-24 lg:pt-28" data-id="element-101" data-mp="2vsxgr8t98hcp">
        <div className="container-x flex min-h-0 flex-1 flex-col" data-id="element-102" data-mp="pope0cf97ph8">
          <div className="flex items-end justify-between gap-6" data-id="element-103" data-mp="kqe3s0l1rcyh">
            <h2 id="process-heading" className="font-serif text-[30px] leading-none tracking-[-0.02em] text-white sm:text-[clamp(40px,4.2vw,56px)]" data-id="element-104" data-mp="kta0xmp2lxlv">
              Our process. <em className="italic text-signal" data-id="element-105" data-mp="b0crs75yxkzx">Your film.</em>
            </h2>
            <p className="hidden font-mono text-[11px] tracking-[0.12em] text-foot md:block" data-id="element-106" data-mp="6zssoy1u47b5">ALWAYS IN THE LOOP · NO SURPRISES</p>
          </div>

          <div className="mt-5 grid min-h-0 flex-1 grid-rows-[minmax(0,1.5fr)_minmax(0,1fr)] gap-3 md:mt-6 lg:mt-8 lg:grid-cols-[1.65fr_1fr] lg:grid-rows-1 lg:gap-5" data-id="element-107" data-mp="22iv2v4akpc8">
            <ProjectorGate frames={processFrames} step={step} progress={progress} data-id="element-108" data-mp="3o8xxl7jdiqve" />
            <ClientChannel step={step} lastStep={lastStep} data-id="element-109" data-mp="1rfmdp8ye6sdg" />
          </div>
        </div>
      </div>
    </section>
  );
}